import { ArrowRight, Coins } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { ToolDefinition } from '../data/tools';

export function ToolCard({ tool, index }: { tool: ToolDefinition; index?: number }) {
  const Icon = tool.icon;
  return (
    <Link to={`/tools/${tool.slug}`} className="tool-card">
      <div className="tool-card-top">
        <span className="tool-icon"><Icon size={22} /></span>
        <div className="tool-card-badges">
          {typeof index === 'number' && <span className="tool-card-index">{String(index + 1).padStart(2, '0')}</span>}
          {tool.badge && <span className="mini-badge">{tool.badge}</span>}
        </div>
      </div>
      <p className="eyebrow">{tool.eyebrow}</p>
      <h3>{tool.name}</h3>
      <p>{tool.description}</p>
      <div className="tool-card-meta">
        <span><Coins size={15} /> {tool.mode === 'free' ? 'Free · 0 credits' : `from ${tool.creditCost} credits`}</span>
        <span>{tool.processingTime}</span>
      </div>
      <div className="tool-card-action">Open {tool.shortName} <ArrowRight size={16} /></div>
    </Link>
  );
}
